import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query';
import { questionDependenciesKeys } from '@data/constants';
import { DependencyUpdateBody } from '@data/sdk/match';
import { MatchingApi } from '@data/utils/axios-instance';
import { APIError } from '@data/utils/types';

export const useEditDependency = (): UseMutationResult<
  unknown,
  APIError<DependencyUpdateBody>,
  { dependencyId: string; values: DependencyUpdateBody },
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ dependencyId, values }) => {
      const response = await MatchingApi.dependency.updateDependency({
        id: dependencyId,
        dependencyUpdateBody: values,
      });
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: questionDependenciesKeys.all() }),
  });
};

export const useDeleteDependency = (): UseMutationResult<unknown, APIError, string, unknown> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (dependencyId) => {
      const response = await MatchingApi.dependency.deleteDependency({ id: dependencyId });
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: questionDependenciesKeys.all() }),
  });
};
